import { type AttributeValue } from "../../attribute/AttributeSet";
import { type UserAttributeSet, UserAttributeType } from "../UserAttributeSet";

import { attributeListToMap } from "@/utils/attributes";

export enum Interest {
  READING = "reading",
  TRAVELING = "traveling",
  COOKING = "cooking",
  FITNESS = "fitness",
  MUSIC = "music",
  PHOTOGRAPHY = "photography",
  GARDENING = "gardening",
  CRAFTS = "crafts",
  WRITING = "writing",
  GAMING = "gaming",
  FISHING = "fishing",
  HIKING = "hiking",
  PAINTING = "painting",
  DANCING = "dancing",
  CYCLING = "cycling",
  YOGA = "yoga",
  MOVIES = "movies",
  ANIMALS = "animals",
  BOARD_GAMES = "board_games",
  EATING = "eat",
  GYM = "gym",
}

const INTEREST_ATTRIBUTE_OPTIONS: ReadonlyArray<AttributeValue> = [
  { id: Interest.READING, label: "Reading", iconLabel: "📚" },
  { id: Interest.TRAVELING, label: "Traveling", iconLabel: "✈️" },
  { id: Interest.COOKING, label: "Cooking", iconLabel: "🍳" },
  { id: Interest.FITNESS, label: "Fitness", iconLabel: "🏋️" },
  { id: Interest.MUSIC, label: "Music", iconLabel: "🎵" },
  { id: Interest.PHOTOGRAPHY, label: "Photography", iconLabel: "📷" },
  { id: Interest.GARDENING, label: "Gardening", iconLabel: "🌱" },
  { id: Interest.CRAFTS, label: "Crafts", iconLabel: "🧶" },
  { id: Interest.WRITING, label: "Writing", iconLabel: "✍️" },
  { id: Interest.GAMING, label: "Gaming", iconLabel: "🎮" },
  { id: Interest.FISHING, label: "Fishing", iconLabel: "🎣" },
  { id: Interest.HIKING, label: "Hiking", iconLabel: "🥾" },
  { id: Interest.PAINTING, label: "Painting", iconLabel: "🎨" },
  { id: Interest.DANCING, label: "Dancing", iconLabel: "💃" },
  { id: Interest.CYCLING, label: "Cycling", iconLabel: "🚴" },
  { id: Interest.YOGA, label: "Yoga", iconLabel: "🧘" },
  { id: Interest.MOVIES, label: "Movies", iconLabel: "🎬" },
  { id: Interest.ANIMALS, label: "Animals", iconLabel: "🐾" },
  { id: Interest.BOARD_GAMES, label: "Board Games", iconLabel: "🎲" },
  { id: Interest.EATING, label: "Eating", iconLabel: "🍽️" },
  { id: Interest.GYM, label: "Gym", iconLabel: "💪" },
];

export const UserInterestAttributeSet: Readonly<UserAttributeSet> = {
  id: UserAttributeType.INTEREST,
  isMultiSelect: true,
  map: attributeListToMap(INTEREST_ATTRIBUTE_OPTIONS),
} as const;
